export const getCurrentLocation = (state) => state?.location?.physicalAddress;
export const getIpAddress = (state) => state?.location?.ipAddress;
